/**
 * Maps V1 triage + field answers into legacy productRecommendation shape
 * so payment estimators and save payloads stay compatible.
 */
import { formatCreditScoreLabel, parseCreditScoreValue } from '../creditScoreInput.js';

export function buildLegacyProductRecommendation(v1Triage = {}, v1Fields = {}) {
  const creditMap = {
    'below-580': 'below-580',
    '580-619': '580-619',
    '620-679': '620-679',
    '680-739': '680-739',
    '740-plus': '740+',
  };

  const creditRaw = v1Triage.creditBand || v1Triage.creditScore;
  const creditNumeric = parseCreditScoreValue(creditRaw);
  const creditScore = creditNumeric
    ? formatCreditScoreLabel(creditNumeric)
    : (creditMap[creditRaw] || '');

  const goal = v1Triage.goal === 'refinance' ? 'refinance' : 'purchase';
  const price = v1Fields.purchasePrice || v1Triage.purchasePrice || v1Fields.estimatedHomeValue || '';
  const down = v1Fields.downPaymentAmount || v1Triage.downPayment || v1Fields.currentLoanBalance || '';

  return {
    purchaseOrRefinance: goal,
    refiGoal: v1Triage.refiGoal === 'cash-out' ? 'cash-out' : 'rate-term',
    propertyUse: 'primary',
    propertyType: 'single-family',
    estimatedValue: String(price || ''),
    downPayment: String(down || ''),
    creditScore,
    annualIncome: v1Fields.grossMonthlyIncome
      ? String(parseFloat(v1Fields.grossMonthlyIncome) * 12)
      : '',
    monthlyDebts: v1Fields.monthlyDebtPayments || '',
    employmentStatus: 'employed',
    loanSizeTier: 'conforming',
  };
}

export function buildRecommendedProductFromV1(productId, v1Product) {
  return {
    id: productId,
    name: v1Product?.name || productId,
    displayName: v1Product?.name || productId,
    productFamily: 'V1',
    routePriority: 0,
    v1: true,
  };
}
